const $ = jQuery.noConflict();

class UpcomingEvents {
    constructor() {
        this.eventTrigger = $('.block-upcoming-event .event-wrap');
        this.eventContent = $('.block-upcoming-event .event-content');
    }
    init() {
        this.eventTrigger.on('click', this.toggleEvent);
        this.eventContent.on('click', (e) => {
            e.stopPropagation();
        });
    }
    toggleEvent() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).find('.event-content').slideUp();
            return;
        }

        $(this).addClass('active');
        $(this).find('.event-content').slideDown();
    }
}

export default new UpcomingEvents();
